import React from 'react';
import ReactDOM from 'react-dom/client';
import TransducerCodeGenerator from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <TransducerCodeGenerator />
  </React.StrictMode>,
);
